import React, { useCallback, useState } from "react";
import {
  CustomCopyToClipboard,
  CustomDialog,
  CustomIconButton,
} from "../../../../../../../../Components";
import { useSelectedTheme, useTranslate } from "../../../../../../../../Hooks";
import { Box, Divider, Typography } from "@material-ui/core";
import { getDownloadableLink } from "../../../../../../../../Helper";
import { GetCoursesDetails } from "../../../../../../../../Services";
import { CourseDetailsDialog } from "../CourseDetailsDialog";

// styles
import useStyle from "./styles";

// icons
import {
  ArrowUpRight,
  FileAttachmentIcon,
} from "../../../../../../../../assets/icons";

function AllCourseRelatedToAgentDialog({ onOpen, onClose, data }) {
  const styles = useStyle();
  const { translate } = useTranslate("NewPropertiesView");
  const {
    theme: { palette },
  } = useSelectedTheme();
  const [isOpenCourseDeatilsDialog, setIsOpenCourseDeatilsDialog] =
    useState(false);
  const [details, setDetails] = useState({});

  const getCoursesDetails = useCallback(async (courseId) => {
    try {
      const response = await GetCoursesDetails(courseId);
      setDetails(response);
      setIsOpenCourseDeatilsDialog(true);
    } catch (error) {
      console.error("Failed to fetch courses:", error);
    } finally {
    }
  }, []);

  return (
    <>
      <CustomDialog
        open={onOpen}
        onClose={() => {
          onClose();
        }}
        title={translate("Courses-list")}
        subtitle={translate("Explore-the-full-list-of-the-agents-courses")}
        cancelText={translate("Cancel")}
        width={"480px"}
        styleCancleButton={{ width: "100%" }}
        content={
          <Box className={styles.wrapperAllCourse}>
            <Box className={styles.wrapperHeaderDialog}>
              <Box className={styles.containerLeftSideHeader}>
                <Box className={styles.wrapperImgProf}>
                  <img
                    className={styles.fullWidth}
                    src={getDownloadableLink(data?.userProfileImage)}
                    alt={translate("Profile-Image")}
                  />
                </Box>
                <Box>{data?.agentName}</Box>
              </Box>
              <CustomCopyToClipboard
                data={data?.staffCode}
                childrenData={"#" + data?.staffCode}
                copyDoneShowTime={1000}
              />
            </Box>
            <Divider />
            <Box className={styles.sectionCourses}>
              {data.courseList.map((course, index) => (
                <Box className={styles.wrapperCourseRow} key={index}>
                  <Box className={styles.container}>
                    <Box className={styles.containerCourseTitle}>
                      <Typography className={styles.courseNameTitle}>
                        {course?.courseName}
                      </Typography>
                      <CustomIconButton
                        variant="text"
                        size="xs"
                        boxShadow="none"
                        color="secondary"
                        onClick={() => {
                          getCoursesDetails(191);
                        }}
                      >
                        <ArrowUpRight
                          width="20"
                          height="20"
                          fill={palette.button.secondaryGray_fg}
                        />
                      </CustomIconButton>
                    </Box>
                    <Box className={styles.courseDesc}>
                      {`matchWith ${course?.matchWith}`}
                    </Box>
                  </Box>
                  <Box className={styles.containerAttatchment}>
                    <Typography className={styles.courseDesc}>1</Typography>
                    <FileAttachmentIcon
                      width="20"
                      height="20"
                      fill={palette.foreground.quarterary}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        }
      />
      {isOpenCourseDeatilsDialog && (
        <CourseDetailsDialog
          onOpen={isOpenCourseDeatilsDialog}
          onClose={() => {
            setIsOpenCourseDeatilsDialog(false);
          }}
          detailsCourse={details}
        />
      )}
    </>
  );
}

export default AllCourseRelatedToAgentDialog;
